const state = {
  isLoading: false
};
export default state;
flarum.reg.add('fof-online-users-widget', 'common/onlineUsersState', state);